module.exports = __webpack_public_path__ + "static/img/merchant_feature_2.39f3b6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/merchant_feature_2.png
// module id = KiYp
// module chunks = 8